export const ON_CART_UPDATE = 'on:cart:update';
export const ON_CELLS_PROCESSED = 'on:cart:processed';
export const ON_CART_CONTENTS_CHANGED = 'on:cart:contents_changed';
export const ON_CART_OPEN = 'on:cart:open';
export const ON_CHECKOUT_UPDATE = 'on:checkout:update';
export const ON_BILLING_DETAILS = 'on:checkout:billing';
export const ON_CART_DETAILS = 'on:cart:billing';
export const ON_CHECKOUT_INFO_READY = 'on:checkout:ready';
export const ON_CHECKOUT_INFO_PARTIAL = 'on:checkout:partial';
export const ON_SHIPPING_METHOD_SELECT = 'on:checkout:shipping_method';
export const ON_CHECKOUT_PAYMENT_METHOD = 'on:checkout:payment_method';
export const ON_FAVOURITE_REMOVED = 'on:fav:removed';


export const ON_SHIPPING_TYPE = 'on:checkout:shipping_type';
export const ON_SHIPPING_TYPE_RESET = 'on:checkout:shipping_type_reset';
export const ON_CHECKOUT_TERMS = 'on:checkout:terms';

export const SHIPPED = 'SHIPPED';
export const LOCAL_PICKUP = 'LOCAL_PICKUP';
export const OTHER = 'OTHER';
export const FREE = 'FREE';
export const EMBROIDERY_WORKS_VAN = 'EMBROIDERY_WORKS_VAN';
export const LAWRIE_EMBROIDERY_VAN = 'LAWRIE_EMBROIDERY_VAN'
export const SAMPLES = 'SAMPLES';
export const GUEST = 'GUEST';

export const OPTION_1 = 'OPTION_1';
export const OPTION_2 = 'OPTION_2';
export const OPTION_3 = 'OPTION_3';
export const OPTION_4 = 'OPTION_4';


export const CREDITS = 'CREDITS';
export const CREDIT_CARD = 'CREDIT_CARD';
export const ACCOUNT_TO_ACCOUNT = 'ACCOUNT_TO_ACCOUNT';
export const ON_ACCOUNT = 'ON_ACCOUNT';

export const ACTION_CART_READ = 'cart-api/read';
export const ACTION_REGISTER_NOTIFICATION = 'cart-api/request-notification';
export const ACTION_UPDATE_CART_QUANTITY = 'cart-api/update-quantity';
export const ACTION_REMOVE_ITEM = 'cart-api/remove-item';
export const ACTION_UPDATE_CART_ITEMS = 'cart-api/update-cart-items';
export const ACTION_UPDATE_CONTACT_INFO = 'cart-api/update-contact-info';
export const ACTION_ADDRESS_DETAILS_READ = 'cart-api/find-addresses';
// export const ACTION_ADDRESS_SAVE = 'cart-api/save-address';
export const ACTION_SYNC_BILLING_SAVE = 'cart-api/sync-billing-details';
export const ACTION_BILLING_SUBMIT = 'cart-api/billing-submit';
export const ACTION_DISCOUNT_CODE = 'cart-api/apply-discount';
export const ACTION_GET_SHIPPING_DETAILS = 'cart-api/get-shipping-options';
export const ACTION_UPDATE_SHIPPING = 'cart-api/update-shipping-option';
export const ACTION_RESET_SHIPPING = 'cart-api/reset-shipping-option';
export const ACTION_SELECT_PICKUP_BRANCH = 'cart-api/select-shipping-location';


export const ACTION_PAYMENT_METHODS = 'cart-api/payment-methods';
export const ACTION_PAYMENT_TYPE_SUBMIT = 'cart-api/payment-method-submit';
export const ACTION_FAVOURITE_PRODUCTS = 'fav-api/get-products';

export const PICKUP_AVAILABLE = 100;
export const PICKUP_IN_STOCK = 200;
export const PICKUP_BACK_ORDER = 300;

